import { DragEvent } from 'react';

export const stopAndPrevent = (e: DragEvent<HTMLDivElement>) => {
  e.stopPropagation();
  e.preventDefault();
};

export const onDragOver = (e: DragEvent<HTMLDivElement>): void => {
  stopAndPrevent(e);
};

export const isValidDragEvent = (
  e: DragEvent<HTMLDivElement>,
  type: string
): boolean => e.dataTransfer.types.includes(type);
